module.exports = __webpack_public_path__ + "static/media/PG-Character-Berry-Egg.6e6f8a81.png";